import { NgModule } from '@angular/core';
import { MailNotifierComponent } from './mail-notifier.component';
import { SharedModule } from '@shared/shared';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [MailNotifierComponent],
  imports: [SharedModule, TranslocoModule],
  exports: [MailNotifierComponent],
})
export class MailNotifierModule {}
